<template>
    <div class="infopoints_view">
    <b-container fluid>
        <b-row>
            <b-col lg="8">
                <SettingsTable class="settingsTable"
                    @onItemSelected="onItemSelected"> </SettingsTable>
            </b-col>

            <b-col>
                
                <SettingsDetails v-if="selectedItem" :item="selectedItem" :reopened="reopenedDetails"></SettingsDetails>
            </b-col>
        </b-row>
    </b-container>
    </div>
</template>

<script>
import SettingsTable from '@/components/System/Settings/SettingsTable'
import SettingsDetails from '@/components/System/Settings/SettingsDetails'


export default {
    name: "Settings",
    components:{
        SettingsTable,
        SettingsDetails
    },
    data: function() {
            return {
                selectedItem: null,
                reopenedDetails: false
            }
        },
    methods:{
        onItemSelected(selectedItem, reopened){
            this.selectedItem = selectedItem;
            this.reopenedDetails = reopened;
        }
    }
   
}
</script>


<style scoped lang="scss"> 

.settingsTable {
  display: inline-block;
  width: 60em;
  overflow:scroll;

}



</style> 
